<template>
  <Providers />
</template>

<script>
// @ is an alias to /src
import Providers from "@/sections/lookupengine/components/Providers.vue";

export default {
  name: "providers",
  components: {
    Providers,
  },
};
</script>
